<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0A192F;
  background-color: #FAF8F5;
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
}
</style>
